<template>
  <div style="margin-top:100px; margin-left:50px; margin-right:50px">
    <loader></loader>
    <no-habilitado v-if="!habilitado" perfil="Administradores"></no-habilitado>
    <div v-if="habilitado">
      <h1>Aprobar Challenges</h1>
      <div v-if="challenges.length == 0" style="text-align:center; padding:20px">
        <h3>No hay desafíos a aprobar</h3>
        <img src="public/images/site/background-no-activity.svg" width="200px" alt="Arkidia" />
      </div>

      <div v-if="challenges.length>0" class="container">
        <div class="row" style="justify-content: center; display:block;">
          <div class="container">
            <div class="row" style="justify-content: center">
              <app-challenge
                v-for="(challenge,index) in challenges"
                :challenge="challenge"
                v-bind:key="index"
              ></app-challenge>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Challenges from "../challenges/Challenge";
import { mapGetters } from "vuex";
import Loader from "../shared/Loader";
import NoHabilitado from "../shared/NoHabilitado";

export default {
  name: "app",
  data() {
    return {
      challenges: [],
      errorMessage: "",
      habilitado: false
    };
  },
  methods: {
    buscarChallenges() {
      var self = this;
      fetch(
        self.pathAPI +
          "challenge_alumno.php?administrador=" +
          this.userLogged.user
      )
        .then(response => response.json())
        .then(data => {
          self.challenges = data;
          const loader = document.querySelector(".loader");
          loader.className += " hidden";
        });
    }
  },
  computed: {
    ...mapGetters(["pathAPI", "userLogged", "categorias", "cursoSeleccionado"])
  },
  components: {
    appChallenge: Challenges,
    NoHabilitado: NoHabilitado,
    Loader: Loader,
  },

  mounted: function() {
    if (this.userLogged.profile == "ADMINISTRADOR") {
      this.habilitado = true;
      this.buscarChallenges();
    } else {
      const loader = document.querySelector(".loader");
      loader.className += " hidden";
    }
  }
};
</script>


<style scoped>
.lds-circle {
  display: inline-block;
  transform: translateZ(1px);
}
.lds-circle > div {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-right: 8px;
  border-radius: 50%;
  background: rgb(16, 131, 112);
  animation: lds-circle 2.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.accion {
  background: #f0eeee;
  padding: 5px 20px;
  border-radius: 15px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminChallenge.vue